





















































































































































import IRPTRepports from '@/store/models/IRPTRepports';
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import TableRowAction from '../shared/TableRowAction.vue';
import Snackbar from '@/components/shared/Snackbar.vue';
import IRolePermission from '@/store/models/IRolePermission';
import ICompany from '@/store/models/ICompany';
@Component({
    components: {
        Snackbar
    }
})
export default class RPTRepportsSelector extends Vue {
    searchRPTRepports: string = "";
    dialog: boolean = false;
    isValid: boolean = true;
    headers: any = [
        { text: 'Company', value: 'companyName' },
        { text: 'Repport Name', value: 'repportName' },
        { text: 'File Path', value: 'templateFilePath' },
        { text: 'User Visible', value: 'isUserVisible' },
        { text: 'Actions', value: '' }
    ];
    editedIndex : number = -1;
    editedItem : IRPTRepports = {
        id: "",
        idCompany: "",
        companyName: "",
        repportName: "",
        templateFilePath: "",
        isUserVisible: true
    }
    defaultItem : IRPTRepports = {
        id: "",
        idCompany: "",
        companyName: "",
        repportName: "",
        templateFilePath: "",
        isUserVisible: true
    }
    sortBy: string = 'repportName';
    sortDesc: boolean = false;

    @Prop({ type: Array, required: true })
    RPTRepportsList !: IRPTRepports[];
    @Prop({ type: Array, required: true })
    Permissions !: IRolePermission[];
    @Prop({ type: Array, required: true })
    CompanyList !: ICompany[];

    selectedRPTRepports : IRPTRepports[] = [];
    selectedCompany : ICompany = {} as ICompany;

    get formTitle() { return this.editedIndex === -1 ? 'New Repport' : 'Edit Repport'; }

    @Watch('dialog')
    onDialogChanged(val: any) {
        val || this.close();
    }

    resetRPTRepports() {
        this.selectedRPTRepports = [];
        this.selectedCompany = {} as ICompany;
    }

    editRPTRepports (item: any, dbox = true) {
        this.editedIndex = this.RPTRepportsList.indexOf(item);
        this.editedItem = Object.assign({}, item);
        this.editedItem.idCompany = item.idCompany;
        this.editedItem.companyName = item.companyName;
        this.dialog = true;
    }

    saveRPTRepports () {
        if ((this.$refs.form as Vue & { validate: () => boolean }).validate()) {
            this.editedItem.idCompany = this.selectedCompany.id;
            this.editedItem.companyName = this.selectedCompany.name;
            if (this.editedItem.isUserVisible === null) {
                this.editedItem.isUserVisible = false;
            }
            if (this.editedIndex > -1 || this.selectedRPTRepports[0]) {
                this.close();
                this.$emit('editRPTRepports', this.editedItem);
                Object.assign(this.RPTRepportsList[this.editedIndex], this.editedItem);
            } else {
                this.selectedRPTRepports[0] = this.editedItem;
                this.$emit('saveRPTRepports', this.editedItem);
            }
            this.close();
        } else {
            this.$emit('showMessageWarning', 'All required fields must be filled out');
        }
    }

    deleteRPTRepports (rptRepport: IRPTRepports) {
        this.$emit('deleteRPTRepports', rptRepport);
        this.close();
    }

    close() : void {
        this.dialog = false;
        this.$nextTick(() => {
            this.editedItem = Object.assign({}, this.defaultItem);
            this.editedIndex = -1;
        });
    }

    selectRPTRepports(item : IRPTRepports) : void {
        if (!this.selectedRPTRepports.includes(item)) {
            this.selectedRPTRepports = [];
            this.selectedRPTRepports = [item];
            this.selectedCompany = this.CompanyList.find(c => c.id === item.idCompany) as ICompany;
        } else {
            this.selectedRPTRepports = [];
        }
    }
    
    showMessageInfo(message: string) {
        (this.$refs.snackbar as Snackbar).showInfo(message);
    }

    showMessageError(message: string) {
        (this.$refs.snackbar as Snackbar).showError(message);
    }
    
    showMessageWarning(message: string) {
        (this.$refs.snackbar as Snackbar).showWarning(message);
    }
}
